// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__cZAk6","navText":"Navbar_navText__1S0TX","navLogo":"Navbar_navLogo__3J_xu","imgLogo":"Navbar_imgLogo__3I76r"};